import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Container, Card, CardBody, CardTitle, Button, Table } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCartPlus, faImage } from '@fortawesome/free-solid-svg-icons';
import { addToCart } from '../../actions/cartActions';
library.add(faCartPlus);
library.add(faImage)

const base_url_image =
    "https://locauditooh-newapp-gallery.s3.ap-south-1.amazonaws.com/";
const convertion_url =
    "https://d1of1iagj88x89.cloudfront.net/fit-in/512x512/";

class MapInfoBox extends Component {

    handleAddToCardtButton = (e) => {
        e.preventDefault();
        this.props.addToCart(this.props.cartItems, this.props.set_marker_data);
    }

    render() {

        const { media_owner, latitude, longitude, city, state, media_type, lighting, locality, vendor, site_code, availability, 
                    photos, site_map,sec_classification } = this.props.set_marker_data;

        let image_url = "#";

        if (site_map) {
            image_url = site_map
        }


        if (photos) {
            if (photos.length > 0) {
                image_url = photos[photos.length - 1].url
            }
        }

        return <Container style={{ width: '500px', height: 'auto' }}>
            <Card>
                <CardBody className="">
                    <CardTitle>Site Details {site_code}
                    </CardTitle>
                    <Row>
                        <Col xs={6}>
                            <img style={{ cursor: 'pointer', margin: 5 }} alt={image_url} style={{width:"100%"}} src={
                                // convertion_url + image_url.replace(base_url_image, "")
                                image_url
                            } onClick={() => window.open(image_url, '_blank')} />
                            <Button className="m-1" size="sm" href="#" onClick={this.handleAddToCardtButton.bind(this)}><FontAwesomeIcon icon="cart-plus" /></Button>

                        </Col>
                        <Col xs={6}>
                            <Table className="mt-1" bordered striped>
                                <tbody>
                                    <tr>
                                        <th>Availability</th>
                                        <td>{availability ? availability : "Not Available"}</td>
                                    </tr>
                                    <tr>
                                        <th>Media Owner</th>
                                        <td>{media_owner ? media_owner : "Not Available"}</td>
                                    </tr>
                                    <tr>
                                        <th>Media Type</th>
                                        <td>{media_type ? media_type : "Not Available"}</td>
                                    </tr>
                                    <tr>
                                        <th>Lighting</th>
                                        <td>{lighting ? lighting : "Not Available"}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>


                    <Table className="mt-1" bordered striped>
                        <tbody>
                            <tr>
                                <th>Latitude</th>
                                <td>{latitude ? latitude : "Not Available"}</td>
                                <th>Longitude</th>
                                <td>{longitude ? longitude : "Not Available"}</td>
                            </tr>
                            <tr>
                                <th>City</th>
                                <td>{city ? city : "Not Available"}</td>
                                <th>State</th>
                                <td>{state ? state : "Not Available"}</td>
                            </tr>

                            <tr>
                                <th>Locality</th>
                                <td>{locality ? locality : "Not Available"}</td>
                                <th>Vendor</th>
                                <td>{vendor ? vendor : "Not Available"}</td>
                            </tr>

                            <tr>
                                <th>SEC</th>
                                <td>{sec_classification ? sec_classification.toString() : "Not Available"}</td>
                            
                            </tr>

                        </tbody>
                    </Table>
                </CardBody>
            </Card>
        </Container>
    }
}

const mapStateToProps = (state) => {
    console.log('state',state)
    return {
        cartItems: state.cart.cartItems,
    }
}

export default connect(mapStateToProps, { addToCart })(MapInfoBox);


// WEBPACK FOOTER //
// ./src/v3/components/createCampaign/mapInfoBox.js